import { Response as ClientResponse } from '@finch-api/common/dist/internal/connect/validate';
import { ProviderConfig } from '@finch-api/common/dist/internal/connect/validate';
import styled from 'styled-components';
import InstructionItem from 'components/Instruction/InstructionItem';
import InstructionBox from 'components/Instruction/InstructionBox';
import InstructionItemsBox from 'components/Instruction/InstructionItemsBox';
import COLORS from 'constants/colors';
import { useEffect } from 'react';
import { usePopOutInstructionsLink } from 'store/pop-out-instructions';

interface WelcomeProps {
  client: ClientResponse;
  provider: ProviderConfig;
}

const InstructionText = styled.p`
  color: ${COLORS.FINCH.BLACK};
  font-family: Inter;
  padding: 6px 8px 6px 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  vertical-align: middle;

  strong {
    font-weight: 600;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Welcome = ({ client, provider }: WelcomeProps) => {
  const { setPopOutInstructionsLink } = usePopOutInstructionsLink();

  // Clear popout instructions when welcome page loads
  useEffect(() => {
    setPopOutInstructionsLink(null, null);
  }, [setPopOutInstructionsLink]);

  return (
    <InstructionBox>
      <InstructionText>
        We&apos;ll guide you through a <strong>one-time</strong> set up process
        to establish your connection. This typically takes about{' '}
        <strong>20 minutes</strong>.
      </InstructionText>
      <InstructionItemsBox>
        <InstructionItem index={1} badgeColor={COLORS.GRAY.GRAY_600}>
          Retrieve your Workday Tenant ID
        </InstructionItem>
        <InstructionItem index={2} badgeColor={COLORS.GRAY.GRAY_600}>
          Create an Integration System User
        </InstructionItem>
        <InstructionItem index={3} badgeColor={COLORS.GRAY.GRAY_600}>
          Configure a Security Group
        </InstructionItem>
        <InstructionItem index={4} badgeColor={COLORS.GRAY.GRAY_600}>
          Configure the Domain Security Policy Permissions for the Security
          Group
        </InstructionItem>
        <InstructionItem index={5} badgeColor={COLORS.GRAY.GRAY_600}>
          Activate the Security Policy Changes
        </InstructionItem>
        <InstructionItem index={6} badgeColor={COLORS.GRAY.GRAY_600}>
          Configure the Authentication Policy
        </InstructionItem>
        <InstructionItem index={7} badgeColor={COLORS.GRAY.GRAY_600}>
          Activate the Authentication Policy Changes
        </InstructionItem>
        <InstructionItem index={8} badgeColor={COLORS.GRAY.GRAY_600}>
          Retrieve your Web Services Endpoint URL
        </InstructionItem>
      </InstructionItemsBox>
    </InstructionBox>
  );
};

export default Welcome;
